import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  keyframes,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useReducedMotion } from "framer-motion";

const gradientMove = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
`;

const PricingHero = () => {
  const shouldReduceMotion = useReducedMotion();
  const floatAnimation = shouldReduceMotion
    ? undefined
    : `${float} 6s ease-in-out infinite`;

  return (
    <Box w="full" position="relative" overflow="hidden" bg="#0a0f1a">
      {/* Animated gradient background */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bgGradient="linear(135deg, #0a0f1a 0%, #1a1f3a 25%, #0f1829 50%, #1a2a4a 75%, #0a0f1a 100%)"
        backgroundSize="400% 400%"
        animation={
          shouldReduceMotion ? undefined : `${gradientMove} 15s ease infinite`
        }
      />

      {/* Floating orbs */}
      <Box
        position="absolute"
        top="10%"
        right="15%"
        w={{ base: "150px", md: "300px" }}
        h={{ base: "150px", md: "300px" }}
        borderRadius="full"
        bg="linear-gradient(135deg, rgba(255, 79, 0, 0.2), rgba(255, 120, 50, 0.1))"
        filter="blur(80px)"
        animation={floatAnimation}
      />
      <Box
        position="absolute"
        bottom="20%"
        left="10%"
        w={{ base: "100px", md: "200px" }}
        h={{ base: "100px", md: "200px" }}
        borderRadius="full"
        bg="linear-gradient(135deg, rgba(0, 150, 255, 0.15), rgba(100, 200, 255, 0.08))"
        filter="blur(60px)"
      />

      {/* Grid pattern overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        opacity={0.03}
        backgroundImage="linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)"
        backgroundSize="50px 50px"
      />

      <VStack
        w="full"
        justify="center"
        px={useBreakpointValue({ base: 6, md: 8 })}
        py={{ base: 20, md: 28 }}
        position="relative"
        zIndex={1}
      >
        <Container maxW="4xl">
          <VStack spacing={{ base: 8, md: 10 }} textAlign="center">
            <Heading
              color="white"
              fontWeight={700}
              fontSize={{ base: "4xl", sm: "5xl", md: "6xl", lg: "7xl" }}
              lineHeight="1.1"
              letterSpacing="-0.02em"
            >
              One Plan,{" "}
              <Text
                as="span"
                bgGradient="linear(to-r, brand.500, brand.700)"
                bgClip="text"
              >
                Complete Protection
              </Text>
            </Heading>

            <Text
              color="text.on-black-secondary"
              maxW="2xl"
              fontSize={{ base: "lg", md: "xl" }}
              lineHeight="1.8"
            >
              Our goal is to keep things simple! One package is all you need. If
              you&apos;re not satisfied, contact us and we&apos;ll refund you
              within the first 14 days.
            </Text>
          </VStack>
        </Container>
      </VStack>
    </Box>
  );
};

export default PricingHero;
